<div class="cpcontent">
    <h2>Beacons</h2>
    <div class="row">
        <div class="col-md-6">
            <button id="newbeacon" class="btn btn-primary" (click)="add()">New Beacon</button>
            <br>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Organization
                            <i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(beacongroups,'orgname',sortArray)"></i>
                        </th>
                        <th>Number of Beacons</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let g of beacongroups">
                        <td class="link" (click)="filter(g.key)">{{g.orgname}}

                        </td>
                        <td>{{g.values.length}}</td>
                    </tr>
                    <tr>
                        <td class="link" (click)="filter(0)">Total</td>
                        <td>{{beacons.length}}</td>
                    </tr>
                </tbody>
            </table>

            <br><br>

        </div>
        <div class="col-md-5">
            <div class="row">
                <button class="btn btn-info btn-sm" style="float:right" (click)="showInfo = !showInfo">Info</button>
                <div *ngIf="showInfo" style="border:solid 1px gray;margin:10px;padding:10px;background-color:aliceblue">
                    <h2>Info and Instructions</h2>
                    <h5>Beacon Modes</h5>
                    Feasybeacons can be switched on and off.
                    <ul>
                        <li>Press long to switch on: 3 led flashes</li>
                        <li>Press short to go into burst mode (see settings below): 1 short led flash</li>
                        <li>Press long to switch off: 1 long led blink</li>
                    </ul>

                    <h5>Distance Calculation</h5>
                    The calculation of distance is based on the power reading from the beacons.
                    The RSSI values (in dB) is converted into distance (in meters) using the following formula:
                    <br>Distance = log ( (RSSI - RSSIat1Meter) / 10 / EnvironmentalFactor)<br>
                    - RSSIat1Meter is measured at configuraiton time<br>
                    - EnvironmentalFactor is a fudge factor that need to be adjusted (here we start with 2.4)
                    <br>

                    <h5>Beacon Configuration</h5>
                    Beacons can be managed using the FeasyBeacon app on your mobile phone.
                    In the app select settings and select the beacon to edit. Password is 000000.<br>
                    Steps: for setup
                    <ul>
                        <li>Give the beacon a meaningful name and assign an organization to it</li>
                        <li>UUID, Major and Minor: Copy UUID over, use number in name for minor. UUID/Major?minor need to be unique</li>
                        <li>Interval is the interval of submitting beacon signals in milliseconds. Use 333 for now.</li>
                        <li>Key / keyDuration are settings for burst modes. Key is interval in milliseconds, keyDuration is duration of burst mode</li>
                        <li>TxPower is the power setting of the beacon. <b>Needs still be to evaluated</b></li>
                        <li><b>RSSI at 1 meter: This is a calibration value that needs to be set by testing. It is used in the distance calculation</b></li>
                        <li><b>Environmental factor: is an adjustment factor used in the distance calculation</b></li>
                        <li>Type is set by clicking on a picture on the right columns</li>
                    </ul>
                    <br>
                    Note: The FeasyBeacon App shows the battery power.
                </div>
                <div *ngIf="beacon.id != null" class="col-md-9">
                    <h4 *ngIf="beacon.id == 0" style="display:inline-block">Add Beacon</h4>
                    <h4 *ngIf="beacon.id > 0" style="display:inline-block">Edit Beacon</h4>
                    <span style="float:right">Id: {{beacon.id}}</span>
                    <br><br>
                    <div class="row">
                        <div class="col-md-2">
                            <img *ngIf="beacon.picUrl?.length > 3" [src]="'../../../assets/beacons/'+beacon.picUrl" alt="beacon" style="max-width:50px" />
                        </div>
                        <div class="col-md-5">
                            <sa-input-text [id]="'name'" [(text)]="beacon.name" [title]="'Name'" [required]="'none'"></sa-input-text>
                        </div>

                        <div class="col-md-5">
                            <sa-select [TagId]="'organization'" [(Id)]="beacon.organizationId" [title]="'Organization'" [options]="organizations"></sa-select>
                        </div>
                    </div>

                    <sa-input-text [id]="'uid'" [(text)]="beacon.uid" [title]="'uid'" [required]="'none'"></sa-input-text>
                    <div class="row">
                        <div class="col-md-6">
                            <sa-input-number [id]="'major'" [(text)]="beacon.major" [title]="'Major'" [required]="'none'"></sa-input-number>
                        </div>
                        <div class="col-md-6">
                            <sa-input-number [id]="'minor'" [(text)]="beacon.minor" [title]="'Minor'" [required]="'none'"></sa-input-number>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4">
                            <sa-input-number [id]="'interval'" [(text)]="beacon.interval" [title]="'Interval (ms)'" [required]="'none'"></sa-input-number>
                            <sa-input-number [id]="'txpower'" [(text)]="beacon.txPower" [title]="'TxPower (dB)'" [required]="'none'"></sa-input-number>
                        </div>
                        <div class="col-md-4">
                            <sa-input-number [id]="'key'" [(text)]="beacon.key" [title]="'Key (ms)'" [required]="'none'"></sa-input-number>
                            <sa-input-number [id]="'rssi1m'" [(text)]="beacon.rssI1meter" [title]="'RSSI at 1 meter  (dB)'" [required]="'none'"></sa-input-number>
                        </div>
                        <div class="col-md-4">
                            <sa-input-number [id]="'keyduration'" [(text)]="beacon.keyDuration" [title]="'keyDuration (ms)'" [required]="'none'"></sa-input-number>
                            <sa-input-number [id]="'envfac'" [(text)]="beacon.envFactor" [title]="'Environmental Factor'" [required]="'none'"></sa-input-number>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <sa-input-text [id]="'comment'" [(text)]="beacon.comment" [title]="'Comment'" [required]="'none'"></sa-input-text>
                        </div>
                        <div class="col-md-6">
                            <sa-input-text [id]="'type'" [(text)]="beacon.picUrl" [title]="'Type'" [required]="'none'"></sa-input-text>
                        </div>
                    </div>
                    <br>
                    <button id="submit" class="btn btn-primary" (click)="submit()">Submit</button>
                    <button id="delete" class="btn btn-warning" (click)="delete(beacon)" style="float:right">Delete</button>
                    <br>
                    <h5>Copy Over</h5>
                    <sa-input-text [(text)]="beaconFromName" [title]="'Beacon From'" [required]="'none'" style="display:inline-block;margin-right:10px"></sa-input-text>
                    <sa-input-text [(text)]="beaconToName" [title]="'Beacon To'" [required]="'none'" style="display:inline-block;margin-right:10px"></sa-input-text>
                    <button class="btn btn-primary" (click)="copy()">Copy</button>
                </div>
                <div class="col-md-3">
                    <h5>Beacon Types</h5>
                    <table class="table table-bordered">
                        <tbody>
                            <tr *ngFor="let bt of beacontypes">
                                <td>
                                    <img [src]="'../../../assets/beacons/'+bt.url" alt="beacon" style="max-width:50px" /><br>
                                    <span class="link" (click)="getPicUrl(bt)">{{bt.name}}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </div>
    <div style="overflow: scroll; height: 600px;">
        <table class="table table-sm">
            <thead style="position: sticky; top: 0;background-color:white">
                <tr>
                    <th>Id <i class="bi bi-sort-up" (click)="sortCol('id')"></i></th>
                    <th>Name <i class="bi bi-sort-up" (click)="sortCol('name')"></i></th>
                    <th>Uid / major - minor</th>
                    <th>Organization</th>
                    <th>Interval</th>
                    <th>TxPower</th>
                    <th>RSSI</th>
                    <th>EF</th>
                    <th>Comment</th>
                    <!-- <th>Where used</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let b of beaconsdisplay">
                    <td>{{b.id}}</td>
                    <td class="link" (click)="selectBeacon(b)">{{b.name}} </td>
                    <td>{{b.uid | limitTo : 5}} {{b.major}} - {{b.minor}}</td>
                    <td>{{lookup(b.organizationId,organizations)}}</td>
                    <td>{{b.interval}}</td>
                    <td>{{b.txPower}}</td>
                    <td>{{b.rssI1meter}}</td>
                    <td>{{b.envFactor}}</td>
                    <td>{{b.comment}}</td>
                    <!-- <td>
                        <button class="btn btn-info" *ngIf="!b.showScenarios" (click)="showScenarios(b)">Expand</button>
                        <button class="btn btn-info" *ngIf="b.showScenarios" (click)="hideScenarios(b)">Collapse</button>
                        {{b.usedlist.scenarioIds.length}}
                        <div *ngIf="b.showScenarios">
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>ScenarioId</th>
                                        <th>ScenarioName</th>
                                        <th>SensorId</th>
                                        <th>SensorName</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let s of b.usedlist.scenarioIds">
                                        <td>{{s.scenarioId}}</td>
                                        <td>{{s.scenarioName}}</td>
                                        <td>{{s.sensorId}}</td>
                                        <td>{{s.sensorName}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            {{b.usedlist | json}}
                        </div>
                    </td> -->
                </tr>
            </tbody>
        </table>
    </div>
<hr>
<button class="btn btn-info"  (click)="showConsistency = !showConsistency">show consistency</button>
<div *ngIf="showConsistency">
    Hello
</div>
</div>